/**
 * Toggles amounts for donations / extra funds for subscriptions.
 */

import { Controller } from "stimulus"
export default class extends Controller {

  static targets = ["custom", "price", "error", "upgradeHint", "upgradeWarning", "upgradeNames"];

  connect() {
    this.basePrice = parseInt(this.element.dataset.basePrice);
    this.element.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', (e) => {
        this.useAnchor(e);
        this.updatePreview(e);
      });
    });
  }

  useCustom() {
    this.element.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false;
    });
    if (this.customTarget.value === "") {
      this.customTarget.value = this.customTarget.min;
    }
  }

  useAnchor() {
    this.customTarget.value = "";
  }

  currentExtraSupport() {
    const radio = this.element.querySelector("input[type='radio']:checked");
    const value = radio ? radio.value : (this.customTarget.value * 100) - this.basePrice;
    return value;
  }

  formattedBasePrice() {
    return (this.basePrice / 100).toFixed(2);
  }

  // Re-renders the order summary and timeline for the ticked purchases and shows what the buyer would lose.
  updateUpgrades() {
    const checked = [...this.element.querySelectorAll("input[name='upgrade_purchase_ids[]']:checked")];

    this.priceTargets.forEach((target) => {
      const url = new URL(target.src, window.location.href);
      url.searchParams.delete('upgrade_purchase_ids[]');
      checked.forEach((box) => url.searchParams.append('upgrade_purchase_ids[]', box.value));
      target.src = url.toString();
    });

    const names = checked.map((box) => box.dataset.name);
    this.upgradeNamesTarget.textContent = new Intl.ListFormat('en', { type: 'conjunction' }).format(names);
    this.upgradeWarningTarget.classList.toggle('hidden', names.length === 0);
    this.upgradeHintTarget.classList.toggle('hidden', names.length > 0);

    const creditCents = checked.reduce((sum, box) => sum + parseInt(box.dataset.creditCents || 0), 0);
    this.dispatch("wallet", { detail: { creditCents } });
  }

  updatePreview() {
    this.errorTarget.classList.add("hidden");

    const currentExtraSupport = this.currentExtraSupport();

    if (currentExtraSupport < 0) {
      this.errorTarget.textContent = "Enter a value greater than the base price ($" + this.formattedBasePrice() + ")";
      this.errorTarget.classList.remove("hidden");
      return;
    }

    this.priceTargets.forEach((target) => {
        const url = new URL(target.src, window.location.href);
        url.searchParams.set('subscription[extra_support_cents]', currentExtraSupport);
        target.src = url.toString();
    });

    // The payment form owns the wallet total (Google Pay / Apple Pay) and applies any upgrade credit to it.
    this.dispatch("wallet", { detail: { extraSupportCents: parseInt(currentExtraSupport) } });
  }
}
